import { render, staticRenderFns } from "./editPurchaseReturn.vue?vue&type=template&id=5b6cddf8&scoped=true"
import script from "./editPurchaseReturn.vue?vue&type=script&lang=js"
export * from "./editPurchaseReturn.vue?vue&type=script&lang=js"
import style0 from "./editPurchaseReturn.vue?vue&type=style&index=0&id=5b6cddf8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6cddf8",
  null
  
)

export default component.exports